import { render, staticRenderFns } from "./dinein.vue?vue&type=template&id=b2bfd196&scoped=true&"
import script from "./dinein.vue?vue&type=script&lang=js&"
export * from "./dinein.vue?vue&type=script&lang=js&"
import style0 from "./dinein.vue?vue&type=style&index=0&id=b2bfd196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bfd196",
  null
  
)

export default component.exports